/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @ts-nocheck
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 PRO React TS Context Provider
import { MaterialUIControllerProvider } from "context";

// Error boundary for crash protection
import ErrorBoundary from "components/ErrorBoundary";

// Initialize Sentry monitoring
import { initializeSentry } from "./config/sentry";
initializeSentry();

// Use non-null assertion on document.getElementById to avoid TypeScript null error
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);

// Render the app component
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <ErrorBoundary level="app">
          <App />
        </ErrorBoundary>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </React.StrictMode>
);
